import type { ArithKey } from './keys';

export const en: Record<ArithKey, string> = {
  'app.title': 'Arithmetic',
  'app.eyebrow': 'Math · Arithmetic',
  'app.tagline': 'Visual computation across the high-school arithmetic curriculum',
  'app.panel.heading': 'Parameters',
  'app.experiment-selector': 'Experiment',
  'panel.enter-number': 'Enter a number',
  'formula.is-prime': 'is prime',
  'experiment.fraction-foundry.label': 'Fraction foundry',
  'experiment.fraction-foundry.info':
    'Stack fraction bars to add, subtract, multiply, and divide. The common-denominator step animates so the why is visible.',
  'experiment.percent-grid.label': 'Percent grid',
  'experiment.percent-grid.info':
    'Shade cells on a 10×10 grid. Live readout in fraction, decimal, percent, and ratio.',
  'experiment.prime-factor-tree.label': 'Prime factor tree',
  'experiment.prime-factor-tree.info':
    'Crack a number into its prime building blocks branch by branch.',
  'experiment.modular-clock.label': 'Modular clock',
  'experiment.modular-clock.info':
    'A clock face that wraps at N positions. Watch addition and multiplication as rotations.',
  'experiment.number-line-surgeon.label': 'Number-line surgeon',
  'experiment.number-line-surgeon.info':
    'Operations as arrows on a number line. Multiplying by a negative is a 180° flip.',
  'experiment.place-value-blocks.label': 'Place-value blocks',
  'experiment.place-value-blocks.info':
    'Drag base-10 blocks to add and subtract. Regrouping is visible when a column reaches ten.',
  'experiment.ratio-mixer.label': 'Ratio mixer',
  'experiment.ratio-mixer.info': 'Two tanks flow into a beaker. The beaker colour is the ratio.',
  'experiment.power-tower.label': 'Power tower',
  'experiment.power-tower.info': 'A doubling or tripling tree grows from one. Roots branch inward.',
  'op.add': 'plus',
  'op.sub': 'minus',
  'op.mul': 'times',
  'op.div': 'divided by',
  'btn.reset': 'Reset',
  'btn.randomise': 'Randomise',
  'btn.advanced': 'Advanced',
  'class.perfect': 'perfect number',
  'class.abundant': 'abundant number',
  'class.deficient': 'deficient number',
  'class.smith': 'Smith number',
  'class.carmichael': 'Carmichael number',
  'mode.basic': 'Basic',
  'mode.inverse': 'Inverse',
  'mode.quad-residues': 'Quadratic residues',
  'mode.fermat': "Fermat's little theorem",
  'mode.recipe': 'Recipe',
  'mode.scale': 'Scale',
  'mode.harmonic': 'Harmonic mean',
  'step.regroup-up': 'Regroup ten into the next column.',
  'step.regroup-down': 'Ungroup one into ten of the next column.',
  'step.common-denominator': 'Find a common denominator.',
  'step.factor-by-prime': 'Divide by a prime factor.',
  'step.scale-by-factor': 'Scale by the factor.',
  'message.not-a-divisor': 'That number does not divide evenly.',
  'message.no-inverse-gcd-greater-than-one':
    'No multiplicative inverse — the two numbers share a factor.',
  'message.repeating-decimal-warning':
    'This decimal repeats forever. Showing a truncated approximation.',
  'message.value-exceeds-safe-integer':
    'The result is too large to display exactly. Showing scientific notation.',
};
